// Note of intent:
// The global context is only meant to be set by "infra" code that manages the
// embedding into EBS. The rest of the code is only meant to "get" things from the context
// through individual functions. The reason for getting pieces of information through
// granular functions is to isolate ourselves as much as possible from breaking changes
// on the EBS side as well as make it easy to find usages of those pieces of data.

let globalContext = null;

export function setEBSGlobalContext(context) {
  globalContext = context;
}

export function isEBSEmbedded() {
  return !!globalContext;
}

export function getEBUserLocale() {
  return globalContext.system.locale;
}

export function getEBUserId() {
  return globalContext.user.userId;
}

export function getEBUsername() {
  return globalContext.user.username;
}

export function getCASIdToken() {
  return globalContext.system.idToken;
}

export function getEBFDInstanceUrl() {
  return globalContext.system.ebfdInstanceUrl;
}

export function getEBGoogleMapsApiKey() {
  return globalContext.system.googleMapApiKey;
}

export function getOrganizationId() {
  return globalContext.organization.orgId;
}
